import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=4c8366ca&scoped=true"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeComponent.vue?vue&type=style&index=0&id=4c8366ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8366ca",
  null
  
)

export default component.exports